/**
 * Hook for fetching procurement packages.
 */

import { gql, useQuery } from "@apollo/client";

export interface ProcurementPackage {
  id: string;
  code: string;
  name: string | null;
  plotId: string | null;
  plannedStart: string | null;
  plannedEnd: string | null;
}

interface ProcurementPackageConnection {
  items: ProcurementPackage[];
  totalCount: number;
  hasNextPage: boolean;
}

interface ProcurementPackagesQueryResult {
  procurementPackages: ProcurementPackageConnection;
}

const GET_PROCUREMENT_PACKAGES = gql`
  query GetProcurementPackages($limit: Int, $offset: Int) {
    procurementPackages(limit: $limit, offset: $offset) {
      items {
        id
        code
        name
        plotId
        plannedStart
        plannedEnd
      }
      totalCount
      hasNextPage
    }
  }
`;

export function useProcurementPackages() {
  const { data, loading, error } = useQuery<ProcurementPackagesQueryResult>(
    GET_PROCUREMENT_PACKAGES,
    {
      variables: { limit: 500, offset: 0 },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    procurementPackages: (data?.procurementPackages.items || []) as ProcurementPackage[],
    totalCount: data?.procurementPackages.totalCount || 0,
    loading,
    error,
  };
}
